import React, { useState, useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import './Styles/style.css'
import TableList from "./Components/TableList";
import PostForm from "./Components/PostForm";
import FilterAndSearch from "./Components/FilterAndSearch";
import MyModal from "./Components/UI/Button/modal/MyModal";
import MyButton from "./Components/UI/Button/MyButton";
import {usePosts} from "./hooks/useCreatePost"
import axios from "axios"; 
import PostServeciApi from "./API/PostServeciApi";
import MyLoader from "./Components/UI/Button/Loader/MyLoader";

function App() {
   const [posts, setposts] = useState([
      
   ])
   const [filter, setFilter] = useState({ sort: "", query: "" })
   const [modal, setModal] = useState(false)
   const sortedAndSearchPosts = usePosts(posts, filter.sort, filter.query)
   const [isLoading, setIsLoading] = useState(false)
   useEffect (() => {
      fetchPosts()
   }, [modal])

   const createPost = (newPost) => {
      setposts([...posts, newPost])
      setModal(false)
   }

   async function fetchPosts (){
      setIsLoading(true)
      const posts = await PostServeciApi.getAllPosts()
      setposts(posts)
      setIsLoading(false)
   }

   const removePost = (post) => {
      setposts(posts.filter(s => s.id !== post.id))
   }

   return (
      <>
         <div className="app w-75 mx-auto">
            <MyButton
               onClick={() => setModal(true)}
               className="btn btn-primary">
               Add Posts
            </MyButton>
            <MyModal modal={modal} setModal={setModal} >
               <PostForm createPost={createPost} />
            </MyModal>
            <FilterAndSearch filter={filter} setFilter={setFilter} />
            {sortedAndSearchPosts.length
               ? <TableList remove={removePost} posts={sortedAndSearchPosts} title="Programming Language" />
               : <h6 className="my-3 text-center">Not Found</h6>
            }
            {isLoading
               ? <div style={{display: "flex", justifyContent: "center", marginTop: 50}}> <MyLoader /> </div>
               : <TableList remove={removePost} posts={sortedAndSearchPosts} title="Programming Language" />
            }

         </div>
      </>
   );
}

export default App;